<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="materials">
                    <icon name="boxes"></icon>
                    รายการวัตถุดิบทั้งหมด </b-nav-item>&nbsp
                <template v-if="canInventoryMaterialsImport">
                    <b-nav-item router-link to="materials-import">
                        <icon name="download"></icon>
                        นำเข้าวัตถุดิบ </b-nav-item>&nbsp
                </template>
                <template v-if="canInventoryMaterialsExport">
                    <b-nav-item router-link to="materials-export">
                        <icon name="upload"></icon>
                        เบิกวัตถุดิบ
                    </b-nav-item>
                </template>&nbsp
                <b-nav-item router-link to="materials-type">
                    <icon name="boxes"></icon>
                    ประเภทวัตถุดิบ
                </b-nav-item>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
import {
    canInventoryMaterialsImport,
    canInventoryMaterialsExport
} from "../../util/Permissions"

export default {
    name: "materials-layout",
    computed: {
        canInventoryMaterialsImport,
        canInventoryMaterialsExport
    },
};
</script>

<style scoped></style>
